import {
  PaymentsIdentityFileModel,
  PaymentIdentityUboModel,
} from '@marketplace-web/domain/payments-identity-data'
import { NationalityCountryModel } from '@marketplace-web/nationality-select/nationality-select-data'
import { AddressModel } from '@marketplace-web/address/address-data'

export enum Field {
  FirstName = 'firstName',
  LastName = 'lastName',
  Birthdate = 'birthdate',
  Nationality = 'nationality',
  SsnSerial = 'ssnSerial',
  PersonalIdNumber = 'personalIdNumber',
  IdentityDocument = 'identityDocument',
  SupportingDocuments = 'supportingDocuments',
}

export type FormModel = {
  [Field.FirstName]: string
  [Field.LastName]: string
  [Field.Birthdate]: string
  [Field.Nationality]?: NationalityCountryModel
  [Field.SsnSerial]?: string
  [Field.PersonalIdNumber]?: string
  [Field.IdentityDocument]: PaymentsIdentityFileModel
  [Field.SupportingDocuments]: Array<PaymentsIdentityFileModel>
  ubos: Array<PaymentIdentityUboModel>
}

export type FormData = {
  firstName: string | null
  lastName: string | null
  birthdate: string | null
  nationality?: NationalityCountryModel | null
  ssnSerial?: string | null
  personalIdNumber?: string | null
  address: AddressModel | null
  isLegalRepresentativeUbo: boolean
  ubos: Array<PaymentIdentityUboModel> | null
  documents: Array<PaymentsIdentityFileModel> | null
}

export type generalErrors = {
  byName: { [fieldName: string]: string }
  names: Array<string>
}

export enum AddressScreenTrackingType {
  Escrow = 'escrow',
  SettingsBillingAddress = 'settings_billing_address',
  SettingsShippingAddress = 'settings_shipping_address',
  SettingsBalanceActivation = 'settings_balance_activation',
}
